import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';

@Component({
    selector: 'app-google-maps-link',
    template: `
    <button
      mat-icon-button
      (click)="openInGoogleMaps()"
      matTooltip="Search in Google Maps"
    >
      <mat-icon class="text-blue-500">location_on</mat-icon>
    </button>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatIconButton, MatTooltip, MatIcon]
})
export class GoogleMapsLinkComponent {
  @Input() address: string;
  @Input() placeId: string | null;

  openInGoogleMaps() {
    const address = this.address.replace('\n', ' ');
    if (this.placeId) {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${address}&query_place_id=${this.placeId}`,
        '_blank'
      );
      return;
    }
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${address}`,
      '_blank'
    );
  }
}
